import classes from './UserFeedback.module.scss';
import CsatScore from '../../components/CsatScore/CsatScore';
import { Button, Spin } from '@peoplegrove/pg-components';
import moment from 'moment';

const UserFeedbackList = ({
  setSelectedSessionAddress,
  userFeedbackData,
  isLoading,
}) => {
  if (isLoading) {
    return <Spin size={24} />;
  }

  return (
    <div>
      {userFeedbackData?.conversations?.map(conversation => (
        <div key={conversation.address} className={classes.feedbackItem}>
          <div className={classes.feedbackHeader}>
            <div className={classes.feedbackUsernameContainer}>
              <span className={classes.feedbackUsername}>
                {conversation.username}
              </span>
              <span className={classes.hubName}>{conversation.hub_name}</span>
            </div>
            <div className={classes.feedbackActions}>
              <Button
                type="link"
                size="small"
                onClick={() => setSelectedSessionAddress(conversation.address)}
              >
                View conversation
              </Button>
              <div>{<CsatScore score={conversation.csatScore} />}</div>
            </div>
          </div>
          <div>{moment(conversation.started_at).format('DD/MM/YYYY')}</div>
          <div className={classes.feedbackComment}>
            {conversation.feedbackComment || 'N/A'}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserFeedbackList;
